import { render, staticRenderFns } from "./landmarkIndex.vue?vue&type=template&id=52fb3bb6&scoped=true&"
import script from "./landmarkIndex.vue?vue&type=script&lang=ts&"
export * from "./landmarkIndex.vue?vue&type=script&lang=ts&"
import style0 from "./landmarkIndex.vue?vue&type=style&index=0&id=52fb3bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fb3bb6",
  null
  
)

export default component.exports